import { render, staticRenderFns } from "./contract.item.record.main.vue?vue&type=template&id=45a9a339&scoped=true&"
import script from "./contract.item.record.main.vue?vue&type=script&lang=js&"
export * from "./contract.item.record.main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a9a339",
  null
  
)

export default component.exports